import { Alert, FormSection } from '@ksyos/design-system';
import { useEffect, useState } from 'react';
import type { ValidationErrors } from '@frontend/utils/validation';
import { BooleanRadioGroupFormGroupField } from '@frontend/components/fields/BooleanRadioGroupField';
import { defaultBooleanRadioGroupFormGroupFieldProps } from '../types';

export interface IOorkPermissionsAddEditProps {
    errors: ValidationErrors;
}

export function OorkPermissionsAddEdit(props: IOorkPermissionsAddEditProps) {
    const { errors } = props;
    const [hasError, setHasError] = useState(false);

    const alertMessage =
        'Om het onderzoek te versturen is het verplicht om het inzage- en blokkeringsrecht te bespreken met de betrokkene en moet de betrokkene toestemming geven om medische informatie te delen met het CBR.';

    useEffect(() => {
        setHasError(
            errors.has('customControlData.inspection_rights_consented') ||
                errors.has('customControlData.share_medical_info_consented')
        );
    }, [errors]);

    return (
        <>
            {hasError ? (
                <Alert appearance="warning">{alertMessage}</Alert>
            ) : (
                <Alert appearance="info">{alertMessage}</Alert>
            )}

            <FormSection
                isBorderless={true}
                title={'Inzage- en blokkeringsrecht'}
                tooltipContent={
                    <>
                        <div>
                            <u>
                                <b>Inzagerecht</b>
                            </u>{' '}
                            geeft de betrokkene het recht om het onderzoeksrapport in te zien.{' '}
                        </div>
                        <div>
                            <u>
                                <b>Blokkeringsrecht</b>
                            </u>{' '}
                            geeft de betrokkene het recht om de uitslag van het rapport niet door het CBR te laten
                            inzien. Het CBR kan de rijgeschiktheid dan niet beoordelen.
                        </div>
                    </>
                }
            >
                {renderBooleanRadioGroupWithConditionedError('inspection_rights_consented')}
            </FormSection>

            <FormSection
                isBorderless={true}
                title={'Toestemming delen medisch informatie met CBR'}
            >
                {renderBooleanRadioGroupWithConditionedError('share_medical_info_consented')}
            </FormSection>
        </>
    );

    function renderBooleanRadioGroupWithConditionedError(fieldKey: string) {
        const error = errors.get(`customControlData.${fieldKey}`);

        return (
            <BooleanRadioGroupFormGroupField
                {...defaultBooleanRadioGroupFormGroupFieldProps}
                error={error ? error : ''}
                fieldKey={fieldKey}
                hasErrors={error !== undefined}
                isRequired={true}
                label="Besproken met betrokkene"
            />
        );
    }
}
